// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"05d918ff","404":"e2c83edb"}[chunkId] + ".chunk.js";
};